var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeco8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 395,
    height: 395,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1252 -1560)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1254.5 1757.5C1254.5 1649.8 1341.8 1562.5 1449.5 1562.5 1557.2 1562.5 1644.5 1649.8 1644.5 1757.5 1644.5 1865.2 1557.2 1952.5 1449.5 1952.5 1341.8 1952.5 1254.5 1865.2 1254.5 1757.5Z",
    stroke: "#000000",
    strokeWidth: 4.58333,
    strokeMiterlimit: 8,
    fill: "#45B382",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeco8);
export default __webpack_public_path__ + "static/media/deco8.1572c301f01d41d95d0b11ebbbb682a6.svg";
export { ForwardRef as ReactComponent };